import ParentCellOrFragment from '@app/src/components/Table/Cells/ParentCellOrFragment'
import Avatar from '@app/src/components/Ui/Avatar'
import { AssessmentOutlined, FlagOutlined, FormatListBulleted } from '@mui/icons-material'
import { Link, Stack, Typography } from '@mui/material'
import React from 'react'
import type { LinkProps as RouterLinkProps } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'
import { TemplateTypeId } from './templateTypeConfig'

const AVATARS: Record<TemplateTypeId, { icon: React.ReactElement; bgColor: string }> = {
  [TemplateTypeId.AiScreening]: {
    icon: <FlagOutlined sx={{ color: 'secondary.main' }} />,
    bgColor: 'success.light',
  },
  [TemplateTypeId.Assessment]: {
    icon: <AssessmentOutlined sx={{ color: 'secondary.main' }} />,
    bgColor: 'success.light',
  },
  [TemplateTypeId.Questionnaire]: {
    icon: <FormatListBulleted sx={{ color: 'text.primary' }} />,
    bgColor: 'grey.100',
  },
}

interface QuestionnaireNameCellProps {
  kind: TemplateTypeId
  title: string
  subtitle: string
  to: RouterLinkProps['to']
}

const QuestionnaireNameCell: React.FC<QuestionnaireNameCellProps> = ({ kind, title, subtitle, to }) => {
  const { icon, bgColor } = AVATARS[kind]

  return (
    <ParentCellOrFragment>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Avatar variant="circular" sx={{ bgcolor: bgColor }}>
          {icon}
        </Avatar>
        <Stack>
          <Link
            component={RouterLink}
            to={to}
            variant="body1"
            color="text.primary"
            underline="none"
            // The row navigates on click too; stop it pushing the same page twice.
            onClick={event => event.stopPropagation()}
          >
            {title}
          </Link>
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        </Stack>
      </Stack>
    </ParentCellOrFragment>
  )
}

export default QuestionnaireNameCell
